var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewSvg = function SvgNewSvg(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 80,
    viewBox: "0 0 272 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11895_12524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: 0,
    width: 300,
    height: 105
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: 0.551758,
    width: 299.656,
    height: 103.989,
    fill: "url(#paint0_linear_11895_12524)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11895_12524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.0703,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.0703,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.61075 6.59404L-14.3817 2.39404V1.54294L-6.61075 -2.65706V-1.67644L-11.9949 1.1729C-12.2539 1.30858 -12.5315 1.45043 -12.8275 1.59845C-13.1112 1.74647 -13.3394 1.86365 -13.5121 1.94999C-13.3394 2.03633 -13.1112 2.15351 -12.8275 2.30153C-12.5315 2.44955 -12.2539 2.5914 -11.9949 2.72708L-6.61075 5.61343V6.59404ZM-2.92477 6.59404V5.61343L2.45937 2.76409C2.7184 2.6284 2.98977 2.48655 3.27347 2.33854C3.5695 2.19052 3.80387 2.07334 3.97655 1.98699C3.80387 1.90065 3.5695 1.78347 3.27347 1.63545C2.98977 1.48744 2.7184 1.34559 2.45937 1.2099L-2.92477 -1.67644V-2.65706L4.84616 1.54294V2.39404L-2.92477 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1797,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1797,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6392 6.59404L17.8683 2.39404V1.54294L25.6392 -2.65706V-1.67644L20.2551 1.1729C19.9961 1.30858 19.7185 1.45043 19.4225 1.59845C19.1388 1.74647 18.9106 1.86365 18.7379 1.94999C18.9106 2.03633 19.1388 2.15351 19.4225 2.30153C19.7185 2.44955 19.9961 2.5914 20.2551 2.72708L25.6392 5.61343V6.59404ZM29.3252 6.59404V5.61343L34.7094 2.76409C34.9684 2.6284 35.2398 2.48655 35.5235 2.33854C35.8195 2.19052 36.0539 2.07334 36.2266 1.98699C36.0539 1.90065 35.8195 1.78347 35.5235 1.63545C35.2398 1.48744 34.9684 1.34559 34.7094 1.2099L29.3252 -1.67644V-2.65706L37.0962 1.54294V2.39404L29.3252 6.59404Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4297,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4297,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8892 6.59404L50.1183 2.39404V1.54294L57.8892 -2.65706V-1.67644L52.5051 1.1729C52.2461 1.30858 51.9685 1.45043 51.6725 1.59845C51.3888 1.74647 51.1606 1.86365 50.9879 1.94999C51.1606 2.03633 51.3888 2.15351 51.6725 2.30153C51.9685 2.44955 52.2461 2.5914 52.5051 2.72708L57.8892 5.61343V6.59404ZM61.5752 6.59404V5.61343L66.9594 2.76409C67.2184 2.6284 67.4898 2.48655 67.7735 2.33854C68.0695 2.19052 68.3039 2.07334 68.4766 1.98699C68.3039 1.90065 68.0695 1.78347 67.7735 1.63545C67.4898 1.48744 67.2184 1.34559 66.9594 1.2099L61.5752 -1.67644V-2.65706L69.3462 1.54294V2.39404L61.5752 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6875,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6875,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1471 6.59404L82.3761 2.39404V1.54294L90.1471 -2.65706V-1.67644L84.7629 1.1729C84.5039 1.30858 84.2264 1.45043 83.9303 1.59845C83.6466 1.74647 83.4184 1.86365 83.2457 1.94999C83.4184 2.03633 83.6466 2.15351 83.9303 2.30153C84.2264 2.44955 84.5039 2.5914 84.7629 2.72708L90.1471 5.61343V6.59404ZM93.833 6.59404V5.61343L99.2172 2.76409C99.4762 2.6284 99.7476 2.48655 100.031 2.33854C100.327 2.19052 100.562 2.07334 100.734 1.98699C100.562 1.90065 100.327 1.78347 100.031 1.63545C99.7476 1.48744 99.4762 1.34559 99.2172 1.2099L93.833 -1.67644V-2.65706L101.604 1.54294V2.39404L93.833 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.938,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.938,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.397 6.59404L114.626 2.39404V1.54294L122.397 -2.65706V-1.67644L117.013 1.1729C116.754 1.30858 116.476 1.45043 116.18 1.59845C115.897 1.74647 115.668 1.86365 115.496 1.94999C115.668 2.03633 115.897 2.15351 116.18 2.30153C116.476 2.44955 116.754 2.5914 117.013 2.72708L122.397 5.61343V6.59404ZM126.083 6.59404V5.61343L131.467 2.76409C131.726 2.6284 131.998 2.48655 132.281 2.33854C132.577 2.19052 132.812 2.07334 132.984 1.98699C132.812 1.90065 132.577 1.78347 132.281 1.63545C131.998 1.48744 131.726 1.34559 131.467 1.2099L126.083 -1.67644V-2.65706L133.854 1.54294V2.39404L126.083 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.188,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.188,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.647 6.59404L146.876 2.39404V1.54294L154.647 -2.65706V-1.67644L149.263 1.1729C149.004 1.30858 148.726 1.45043 148.43 1.59845C148.147 1.74647 147.918 1.86365 147.746 1.94999C147.918 2.03633 148.147 2.15351 148.43 2.30153C148.726 2.44955 149.004 2.5914 149.263 2.72708L154.647 5.61343V6.59404ZM158.333 6.59404V5.61343L163.717 2.76409C163.976 2.6284 164.248 2.48655 164.531 2.33854C164.827 2.19052 165.062 2.07334 165.234 1.98699C165.062 1.90065 164.827 1.78347 164.531 1.63545C164.248 1.48744 163.976 1.34559 163.717 1.2099L158.333 -1.67644V-2.65706L166.104 1.54294V2.39404L158.333 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.438,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.438,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.897 6.59404L179.126 2.39404V1.54294L186.897 -2.65706V-1.67644L181.513 1.1729C181.254 1.30858 180.976 1.45043 180.68 1.59845C180.397 1.74647 180.168 1.86365 179.996 1.94999C180.168 2.03633 180.397 2.15351 180.68 2.30153C180.976 2.44955 181.254 2.5914 181.513 2.72708L186.897 5.61343V6.59404ZM190.583 6.59404V5.61343L195.967 2.76409C196.226 2.6284 196.498 2.48655 196.781 2.33854C197.077 2.19052 197.312 2.07334 197.484 1.98699C197.312 1.90065 197.077 1.78347 196.781 1.63545C196.498 1.48744 196.226 1.34559 195.967 1.2099L190.583 -1.67644V-2.65706L198.354 1.54294V2.39404L190.583 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.688,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.688,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.147 6.59404L211.376 2.39404V1.54294L219.147 -2.65706V-1.67644L213.763 1.1729C213.504 1.30858 213.226 1.45043 212.93 1.59845C212.647 1.74647 212.418 1.86365 212.246 1.94999C212.418 2.03633 212.647 2.15351 212.93 2.30153C213.226 2.44955 213.504 2.5914 213.763 2.72708L219.147 5.61343V6.59404ZM222.833 6.59404V5.61343L228.217 2.76409C228.476 2.6284 228.748 2.48655 229.031 2.33854C229.327 2.19052 229.562 2.07334 229.734 1.98699C229.562 1.90065 229.327 1.78347 229.031 1.63545C228.748 1.48744 228.476 1.34559 228.217 1.2099L222.833 -1.67644V-2.65706L230.604 1.54294V2.39404L222.833 6.59404Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.938,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.938,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.397 6.59404L243.626 2.39404V1.54294L251.397 -2.65706V-1.67644L246.013 1.1729C245.754 1.30858 245.476 1.45043 245.18 1.59845C244.897 1.74647 244.668 1.86365 244.496 1.94999C244.668 2.03633 244.897 2.15351 245.18 2.30153C245.476 2.44955 245.754 2.5914 246.013 2.72708L251.397 5.61343V6.59404ZM255.083 6.59404V5.61343L260.467 2.76409C260.726 2.6284 260.998 2.48655 261.281 2.33854C261.577 2.19052 261.812 2.07334 261.984 1.98699C261.812 1.90065 261.577 1.78347 261.281 1.63545C260.998 1.48744 260.726 1.34559 260.467 1.2099L255.083 -1.67644V-2.65706L262.854 1.54294V2.39404L255.083 6.59404Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.188,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.188,
    y: -7.63668,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.148403,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.148403,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3111 30.219L3.5402 26.019V25.1679L11.3111 20.9679V21.9486L5.92698 24.7979C5.66795 24.9336 5.39042 25.0754 5.09438 25.2234C4.81068 25.3715 4.58249 25.4886 4.4098 25.575C4.58249 25.6613 4.81068 25.7785 5.09438 25.9265C5.39042 26.0746 5.66795 26.2164 5.92698 26.3521L11.3111 29.2384V30.219ZM14.9971 30.219V29.2384L20.3812 26.3891C20.6403 26.2534 20.9116 26.1116 21.1953 25.9635C21.4914 25.8155 21.7257 25.6983 21.8984 25.612C21.7257 25.5257 21.4914 25.4085 21.1953 25.2605C20.9116 25.1124 20.6403 24.9706 20.3812 24.8349L14.9971 21.9486V20.9679L22.768 25.1679V26.019L14.9971 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1094,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1094,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5689 30.219L35.798 26.019V25.1679L43.5689 20.9679V21.9486L38.1848 24.7979C37.9258 24.9336 37.6482 25.0754 37.3522 25.2234C37.0685 25.3715 36.8403 25.4886 36.6676 25.575C36.8403 25.6613 37.0685 25.7785 37.3522 25.9265C37.6482 26.0746 37.9258 26.2164 38.1848 26.3521L43.5689 29.2384V30.219ZM47.2549 30.219V29.2384L52.6391 26.3891C52.8981 26.2534 53.1695 26.1116 53.4532 25.9635C53.7492 25.8155 53.9836 25.6983 54.1562 25.612C53.9836 25.5257 53.7492 25.4085 53.4532 25.2605C53.1695 25.1124 52.8981 24.9706 52.6391 24.8349L47.2549 21.9486V20.9679L55.0258 25.1679V26.019L47.2549 30.219Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.3594,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.3594,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8189 30.219L68.048 26.019V25.1679L75.8189 20.9679V21.9486L70.4348 24.7979C70.1758 24.9336 69.8982 25.0754 69.6022 25.2234C69.3185 25.3715 69.0903 25.4886 68.9176 25.575C69.0903 25.6613 69.3185 25.7785 69.6022 25.9265C69.8982 26.0746 70.1758 26.2164 70.4348 26.3521L75.8189 29.2384V30.219ZM79.5049 30.219V29.2384L84.8891 26.3891C85.1481 26.2534 85.4195 26.1116 85.7032 25.9635C85.9992 25.8155 86.2336 25.6983 86.4062 25.612C86.2336 25.5257 85.9992 25.4085 85.7032 25.2605C85.4195 25.1124 85.1481 24.9706 84.8891 24.8349L79.5049 21.9486V20.9679L87.2758 25.1679V26.019L79.5049 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6094,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6094,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.069 30.219L100.298 26.019V25.1679L108.069 20.9679V21.9486L102.685 24.7979C102.426 24.9336 102.148 25.0754 101.852 25.2234C101.568 25.3715 101.34 25.4886 101.168 25.575C101.34 25.6613 101.568 25.7785 101.852 25.9265C102.148 26.0746 102.426 26.2164 102.685 26.3521L108.069 29.2384V30.219ZM111.755 30.219V29.2384L117.139 26.3891C117.398 26.2534 117.669 26.1116 117.953 25.9635C118.249 25.8155 118.484 25.6983 118.656 25.612C118.484 25.5257 118.249 25.4085 117.953 25.2605C117.669 25.1124 117.398 24.9706 117.139 24.8349L111.755 21.9486V20.9679L119.526 25.1679V26.019L111.755 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.859,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.859,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.319 30.219L132.548 26.019V25.1679L140.319 20.9679V21.9486L134.935 24.7979C134.676 24.9336 134.398 25.0754 134.102 25.2234C133.818 25.3715 133.59 25.4886 133.418 25.575C133.59 25.6613 133.818 25.7785 134.102 25.9265C134.398 26.0746 134.676 26.2164 134.935 26.3521L140.319 29.2384V30.219ZM144.005 30.219V29.2384L149.389 26.3891C149.648 26.2534 149.919 26.1116 150.203 25.9635C150.499 25.8155 150.734 25.6983 150.906 25.612C150.734 25.5257 150.499 25.4085 150.203 25.2605C149.919 25.1124 149.648 24.9706 149.389 24.8349L144.005 21.9486V20.9679L151.776 25.1679V26.019L144.005 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.109,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.109,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.569 30.219L164.798 26.019V25.1679L172.569 20.9679V21.9486L167.185 24.7979C166.926 24.9336 166.648 25.0754 166.352 25.2234C166.068 25.3715 165.84 25.4886 165.668 25.575C165.84 25.6613 166.068 25.7785 166.352 25.9265C166.648 26.0746 166.926 26.2164 167.185 26.3521L172.569 29.2384V30.219ZM176.255 30.219V29.2384L181.639 26.3891C181.898 26.2534 182.169 26.1116 182.453 25.9635C182.749 25.8155 182.984 25.6983 183.156 25.612C182.984 25.5257 182.749 25.4085 182.453 25.2605C182.169 25.1124 181.898 24.9706 181.639 24.8349L176.255 21.9486V20.9679L184.026 25.1679V26.019L176.255 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.359,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.359,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.819 30.219L197.048 26.019V25.1679L204.819 20.9679V21.9486L199.435 24.7979C199.176 24.9336 198.898 25.0754 198.602 25.2234C198.318 25.3715 198.09 25.4886 197.918 25.575C198.09 25.6613 198.318 25.7785 198.602 25.9265C198.898 26.0746 199.176 26.2164 199.435 26.3521L204.819 29.2384V30.219ZM208.505 30.219V29.2384L213.889 26.3891C214.148 26.2534 214.419 26.1116 214.703 25.9635C214.999 25.8155 215.234 25.6983 215.406 25.612C215.234 25.5257 214.999 25.4085 214.703 25.2605C214.419 25.1124 214.148 24.9706 213.889 24.8349L208.505 21.9486V20.9679L216.276 25.1679V26.019L208.505 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.609,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.609,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.069 30.219L229.298 26.019V25.1679L237.069 20.9679V21.9486L231.685 24.7979C231.426 24.9336 231.148 25.0754 230.852 25.2234C230.568 25.3715 230.34 25.4886 230.168 25.575C230.34 25.6613 230.568 25.7785 230.852 25.9265C231.148 26.0746 231.426 26.2164 231.685 26.3521L237.069 29.2384V30.219ZM240.755 30.219V29.2384L246.139 26.3891C246.398 26.2534 246.669 26.1116 246.953 25.9635C247.249 25.8155 247.484 25.6983 247.656 25.612C247.484 25.5257 247.249 25.4085 246.953 25.2605C246.669 25.1124 246.398 24.9706 246.139 24.8349L240.755 21.9486V20.9679L248.526 25.1679V26.019L240.755 30.219Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.867,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.867,
    y: 15.9883,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.327 30.219L261.556 26.019V25.1679L269.327 20.9679V21.9486L263.943 24.7979C263.684 24.9336 263.406 25.0754 263.11 25.2234C262.826 25.3715 262.598 25.4886 262.425 25.575C262.598 25.6613 262.826 25.7785 263.11 25.9265C263.406 26.0746 263.684 26.2164 263.943 26.3521L269.327 29.2384V30.219ZM273.013 30.219V29.2384L278.397 26.3891C278.656 26.2534 278.927 26.1116 279.211 25.9635C279.507 25.8155 279.741 25.6983 279.914 25.612C279.741 25.5257 279.507 25.4085 279.211 25.2605C278.927 25.1124 278.656 24.9706 278.397 24.8349L273.013 21.9486V20.9679L280.784 25.1679V26.019L273.013 30.219Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.0703,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.0703,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.61075 53.845L-14.3817 49.645V48.7939L-6.61075 44.5939V45.5745L-11.9949 48.4239C-12.2539 48.5596 -12.5315 48.7014 -12.8275 48.8494C-13.1112 48.9974 -13.3394 49.1146 -13.5121 49.201C-13.3394 49.2873 -13.1112 49.4045 -12.8275 49.5525C-12.5315 49.7005 -12.2539 49.8424 -11.9949 49.9781L-6.61075 52.8644V53.845ZM-2.92477 53.845V52.8644L2.45937 50.0151C2.7184 49.8794 2.98977 49.7375 3.27347 49.5895C3.5695 49.4415 3.80387 49.3243 3.97655 49.238C3.80387 49.1516 3.5695 49.0344 3.27347 48.8864C2.98977 48.7384 2.7184 48.5966 2.45937 48.4609L-2.92477 45.5745V44.5939L4.84616 48.7939V49.645L-2.92477 53.845Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1797,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1797,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6392 53.845L17.8683 49.645V48.7939L25.6392 44.5939V45.5745L20.2551 48.4239C19.9961 48.5596 19.7185 48.7014 19.4225 48.8494C19.1388 48.9974 18.9106 49.1146 18.7379 49.201C18.9106 49.2873 19.1388 49.4045 19.4225 49.5525C19.7185 49.7005 19.9961 49.8424 20.2551 49.9781L25.6392 52.8644V53.845ZM29.3252 53.845V52.8644L34.7094 50.0151C34.9684 49.8794 35.2398 49.7375 35.5235 49.5895C35.8195 49.4415 36.0539 49.3243 36.2266 49.238C36.0539 49.1516 35.8195 49.0344 35.5235 48.8864C35.2398 48.7384 34.9684 48.5966 34.7094 48.4609L29.3252 45.5745V44.5939L37.0962 48.7939V49.645L29.3252 53.845Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4297,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4297,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8892 53.845L50.1183 49.645V48.7939L57.8892 44.5939V45.5745L52.5051 48.4239C52.2461 48.5596 51.9685 48.7014 51.6725 48.8494C51.3888 48.9974 51.1606 49.1146 50.9879 49.201C51.1606 49.2873 51.3888 49.4045 51.6725 49.5525C51.9685 49.7005 52.2461 49.8424 52.5051 49.9781L57.8892 52.8644V53.845ZM61.5752 53.845V52.8644L66.9594 50.0151C67.2184 49.8794 67.4898 49.7375 67.7735 49.5895C68.0695 49.4415 68.3039 49.3243 68.4766 49.238C68.3039 49.1516 68.0695 49.0344 67.7735 48.8864C67.4898 48.7384 67.2184 48.5966 66.9594 48.4609L61.5752 45.5745V44.5939L69.3462 48.7939V49.645L61.5752 53.845Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6875,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6875,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1471 53.845L82.3761 49.645V48.7939L90.1471 44.5939V45.5745L84.7629 48.4239C84.5039 48.5596 84.2264 48.7014 83.9303 48.8494C83.6466 48.9974 83.4184 49.1146 83.2457 49.201C83.4184 49.2873 83.6466 49.4045 83.9303 49.5525C84.2264 49.7005 84.5039 49.8424 84.7629 49.9781L90.1471 52.8644V53.845ZM93.833 53.845V52.8644L99.2172 50.0151C99.4762 49.8794 99.7476 49.7375 100.031 49.5895C100.327 49.4415 100.562 49.3243 100.734 49.238C100.562 49.1516 100.327 49.0344 100.031 48.8864C99.7476 48.7384 99.4762 48.5966 99.2172 48.4609L93.833 45.5745V44.5939L101.604 48.7939V49.645L93.833 53.845Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.938,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.938,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.397 53.845L114.626 49.645V48.7939L122.397 44.5939V45.5745L117.013 48.4239C116.754 48.5596 116.476 48.7014 116.18 48.8494C115.897 48.9974 115.668 49.1146 115.496 49.201C115.668 49.2873 115.897 49.4045 116.18 49.5525C116.476 49.7005 116.754 49.8424 117.013 49.9781L122.397 52.8644V53.845ZM126.083 53.845V52.8644L131.467 50.0151C131.726 49.8794 131.998 49.7375 132.281 49.5895C132.577 49.4415 132.812 49.3243 132.984 49.238C132.812 49.1516 132.577 49.0344 132.281 48.8864C131.998 48.7384 131.726 48.5966 131.467 48.4609L126.083 45.5745V44.5939L133.854 48.7939V49.645L126.083 53.845Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.188,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.188,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.647 53.845L146.876 49.645V48.7939L154.647 44.5939V45.5745L149.263 48.4239C149.004 48.5596 148.726 48.7014 148.43 48.8494C148.147 48.9974 147.918 49.1146 147.746 49.201C147.918 49.2873 148.147 49.4045 148.43 49.5525C148.726 49.7005 149.004 49.8424 149.263 49.9781L154.647 52.8644V53.845ZM158.333 53.845V52.8644L163.717 50.0151C163.976 49.8794 164.248 49.7375 164.531 49.5895C164.827 49.4415 165.062 49.3243 165.234 49.238C165.062 49.1516 164.827 49.0344 164.531 48.8864C164.248 48.7384 163.976 48.5966 163.717 48.4609L158.333 45.5745V44.5939L166.104 48.7939V49.645L158.333 53.845Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.438,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.438,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.897 53.845L179.126 49.645V48.7939L186.897 44.5939V45.5745L181.513 48.4239C181.254 48.5596 180.976 48.7014 180.68 48.8494C180.397 48.9974 180.168 49.1146 179.996 49.201C180.168 49.2873 180.397 49.4045 180.68 49.5525C180.976 49.7005 181.254 49.8424 181.513 49.9781L186.897 52.8644V53.845ZM190.583 53.845V52.8644L195.967 50.0151C196.226 49.8794 196.498 49.7375 196.781 49.5895C197.077 49.4415 197.312 49.3243 197.484 49.238C197.312 49.1516 197.077 49.0344 196.781 48.8864C196.498 48.7384 196.226 48.5966 195.967 48.4609L190.583 45.5745V44.5939L198.354 48.7939V49.645L190.583 53.845Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.688,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.688,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.147 53.845L211.376 49.645V48.7939L219.147 44.5939V45.5745L213.763 48.4239C213.504 48.5596 213.226 48.7014 212.93 48.8494C212.647 48.9974 212.418 49.1146 212.246 49.201C212.418 49.2873 212.647 49.4045 212.93 49.5525C213.226 49.7005 213.504 49.8424 213.763 49.9781L219.147 52.8644V53.845ZM222.833 53.845V52.8644L228.217 50.0151C228.476 49.8794 228.748 49.7375 229.031 49.5895C229.327 49.4415 229.562 49.3243 229.734 49.238C229.562 49.1516 229.327 49.0344 229.031 48.8864C228.748 48.7384 228.476 48.5966 228.217 48.4609L222.833 45.5745V44.5939L230.604 48.7939V49.645L222.833 53.845Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.938,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.938,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.397 53.845L243.626 49.645V48.7939L251.397 44.5939V45.5745L246.013 48.4239C245.754 48.5596 245.476 48.7014 245.18 48.8494C244.897 48.9974 244.668 49.1146 244.496 49.201C244.668 49.2873 244.897 49.4045 245.18 49.5525C245.476 49.7005 245.754 49.8424 246.013 49.9781L251.397 52.8644V53.845ZM255.083 53.845V52.8644L260.467 50.0151C260.726 49.8794 260.998 49.7375 261.281 49.5895C261.577 49.4415 261.812 49.3243 261.984 49.238C261.812 49.1516 261.577 49.0344 261.281 48.8864C260.998 48.7384 260.726 48.5966 260.467 48.4609L255.083 45.5745V44.5939L262.854 48.7939V49.645L255.083 53.845Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.188,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.188,
    y: 39.6143,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.148403,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.148403,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3111 77.47L3.5402 73.27V72.4189L11.3111 68.2189V69.1995L5.92698 72.0489C5.66795 72.1846 5.39042 72.3264 5.09438 72.4744C4.81068 72.6224 4.58249 72.7396 4.4098 72.826C4.58249 72.9123 4.81068 73.0295 5.09438 73.1775C5.39042 73.3255 5.66795 73.4674 5.92698 73.6031L11.3111 76.4894V77.47ZM14.9971 77.47V76.4894L20.3812 73.6401C20.6403 73.5044 20.9116 73.3625 21.1953 73.2145C21.4914 73.0665 21.7257 72.9493 21.8984 72.863C21.7257 72.7766 21.4914 72.6594 21.1953 72.5114C20.9116 72.3634 20.6403 72.2216 20.3812 72.0859L14.9971 69.1995V68.2189L22.768 72.4189V73.27L14.9971 77.47Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1094,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1094,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5689 77.47L35.798 73.27V72.4189L43.5689 68.2189V69.1995L38.1848 72.0489C37.9258 72.1846 37.6482 72.3264 37.3522 72.4744C37.0685 72.6224 36.8403 72.7396 36.6676 72.826C36.8403 72.9123 37.0685 73.0295 37.3522 73.1775C37.6482 73.3255 37.9258 73.4674 38.1848 73.6031L43.5689 76.4894V77.47ZM47.2549 77.47V76.4894L52.6391 73.6401C52.8981 73.5044 53.1695 73.3625 53.4532 73.2145C53.7492 73.0665 53.9836 72.9493 54.1562 72.863C53.9836 72.7766 53.7492 72.6594 53.4532 72.5114C53.1695 72.3634 52.8981 72.2216 52.6391 72.0859L47.2549 69.1995V68.2189L55.0258 72.4189V73.27L47.2549 77.47Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.3594,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.3594,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8189 77.47L68.048 73.27V72.4189L75.8189 68.2189V69.1995L70.4348 72.0489C70.1758 72.1846 69.8982 72.3264 69.6022 72.4744C69.3185 72.6224 69.0903 72.7396 68.9176 72.826C69.0903 72.9123 69.3185 73.0295 69.6022 73.1775C69.8982 73.3255 70.1758 73.4674 70.4348 73.6031L75.8189 76.4894V77.47ZM79.5049 77.47V76.4894L84.8891 73.6401C85.1481 73.5044 85.4195 73.3625 85.7032 73.2145C85.9992 73.0665 86.2336 72.9493 86.4062 72.863C86.2336 72.7766 85.9992 72.6594 85.7032 72.5114C85.4195 72.3634 85.1481 72.2216 84.8891 72.0859L79.5049 69.1995V68.2189L87.2758 72.4189V73.27L79.5049 77.47Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6094,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6094,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.069 77.47L100.298 73.27V72.4189L108.069 68.2189V69.1995L102.685 72.0489C102.426 72.1846 102.148 72.3264 101.852 72.4744C101.568 72.6224 101.34 72.7396 101.168 72.826C101.34 72.9123 101.568 73.0295 101.852 73.1775C102.148 73.3255 102.426 73.4674 102.685 73.6031L108.069 76.4894V77.47ZM111.755 77.47V76.4894L117.139 73.6401C117.398 73.5044 117.669 73.3625 117.953 73.2145C118.249 73.0665 118.484 72.9493 118.656 72.863C118.484 72.7766 118.249 72.6594 117.953 72.5114C117.669 72.3634 117.398 72.2216 117.139 72.0859L111.755 69.1995V68.2189L119.526 72.4189V73.27L111.755 77.47Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.859,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.859,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.319 77.47L132.548 73.27V72.4189L140.319 68.2189V69.1995L134.935 72.0489C134.676 72.1846 134.398 72.3264 134.102 72.4744C133.818 72.6224 133.59 72.7396 133.418 72.826C133.59 72.9123 133.818 73.0295 134.102 73.1775C134.398 73.3255 134.676 73.4674 134.935 73.6031L140.319 76.4894V77.47ZM144.005 77.47V76.4894L149.389 73.6401C149.648 73.5044 149.919 73.3625 150.203 73.2145C150.499 73.0665 150.734 72.9493 150.906 72.863C150.734 72.7766 150.499 72.6594 150.203 72.5114C149.919 72.3634 149.648 72.2216 149.389 72.0859L144.005 69.1995V68.2189L151.776 72.4189V73.27L144.005 77.47Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.109,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.109,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.569 77.47L164.798 73.27V72.4189L172.569 68.2189V69.1995L167.185 72.0489C166.926 72.1846 166.648 72.3264 166.352 72.4744C166.068 72.6224 165.84 72.7396 165.668 72.826C165.84 72.9123 166.068 73.0295 166.352 73.1775C166.648 73.3255 166.926 73.4674 167.185 73.6031L172.569 76.4894V77.47ZM176.255 77.47V76.4894L181.639 73.6401C181.898 73.5044 182.169 73.3625 182.453 73.2145C182.749 73.0665 182.984 72.9493 183.156 72.863C182.984 72.7766 182.749 72.6594 182.453 72.5114C182.169 72.3634 181.898 72.2216 181.639 72.0859L176.255 69.1995V68.2189L184.026 72.4189V73.27L176.255 77.47Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.359,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.359,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.819 77.47L197.048 73.27V72.4189L204.819 68.2189V69.1995L199.435 72.0489C199.176 72.1846 198.898 72.3264 198.602 72.4744C198.318 72.6224 198.09 72.7396 197.918 72.826C198.09 72.9123 198.318 73.0295 198.602 73.1775C198.898 73.3255 199.176 73.4674 199.435 73.6031L204.819 76.4894V77.47ZM208.505 77.47V76.4894L213.889 73.6401C214.148 73.5044 214.419 73.3625 214.703 73.2145C214.999 73.0665 215.234 72.9493 215.406 72.863C215.234 72.7766 214.999 72.6594 214.703 72.5114C214.419 72.3634 214.148 72.2216 213.889 72.0859L208.505 69.1995V68.2189L216.276 72.4189V73.27L208.505 77.47Z",
    fill: "#F35B22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.609,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.609,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.069 77.47L229.298 73.27V72.4189L237.069 68.2189V69.1995L231.685 72.0489C231.426 72.1846 231.148 72.3264 230.852 72.4744C230.568 72.6224 230.34 72.7396 230.168 72.826C230.34 72.9123 230.568 73.0295 230.852 73.1775C231.148 73.3255 231.426 73.4674 231.685 73.6031L237.069 76.4894V77.47ZM240.755 77.47V76.4894L246.139 73.6401C246.398 73.5044 246.669 73.3625 246.953 73.2145C247.249 73.0665 247.484 72.9493 247.656 72.863C247.484 72.7766 247.249 72.6594 246.953 72.5114C246.669 72.3634 246.398 72.2216 246.139 72.0859L240.755 69.1995V68.2189L248.526 72.4189V73.27L240.755 77.47Z",
    fill: "#FFDDC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.867,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.867,
    y: 63.2393,
    width: 27.0474,
    height: 18.4218,
    rx: 6.64923,
    stroke: "#FFDDC8",
    strokeWidth: 0.578194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.327 77.47L261.556 73.27V72.4189L269.327 68.2189V69.1995L263.943 72.0489C263.684 72.1846 263.406 72.3264 263.11 72.4744C262.826 72.6224 262.598 72.7396 262.425 72.826C262.598 72.9123 262.826 73.0295 263.11 73.1775C263.406 73.3255 263.684 73.4674 263.943 73.6031L269.327 76.4894V77.47ZM273.013 77.47V76.4894L278.397 73.6401C278.656 73.5044 278.927 73.3625 279.211 73.2145C279.507 73.0665 279.741 72.9493 279.914 72.863C279.741 72.7766 279.507 72.6594 279.211 72.5114C278.927 72.3634 278.656 72.2216 278.397 72.0859L273.013 69.1995V68.2189L280.784 72.4189V73.27L273.013 77.47Z",
    fill: "#FFDDC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11895_12524",
    x1: 195.056,
    y1: 14.9782,
    x2: 177.159,
    y2: 110.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F35B22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365596,
    stopColor: "#F35B22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870486,
    stopColor: "#F35B22"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewSvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/NewSVG.07555708.svg";